import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getIncidentComments: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS]
				.GET_INCIDENT_COMMENTS,
	},
	createIncidentComment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS]
				.CREATE_INCIDENT_COMMENT,
	},
	getIncidentComment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS]
				.GET_INCIDENT_COMMENT
	},
	patchIncidentComment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS]
				.PATCH_INCIDENT_COMMENT,
	},
	putIncidentComment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS]
				.PUT_INCIDENT_COMMENT,
	},
	deleteIncidentComment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS]
				.DELETE_INCIDENT_COMMENT,
	},
}
